

(function ($) {

	$('.mv').slick({
		arrows: false,
		fade: true,
		autoplay: true
	});

	var pagetop = $('.pagetop');
	// ボタン非表示
	pagetop.hide();
	// 100px スクロールしたらボタン表示
	$(window).scroll(function () {
		if ($(this).scrollTop() > 100) {
			pagetop.fadeIn();
		} else {
			pagetop.fadeOut();
		}
	});
	pagetop.click(function () {
		$('body, html').animate({ scrollTop: 0 }, 500);
		return false;
	});


	$('.sp-menu').click(function () {
		if ($(this).hasClass('open')) {
			$(this).removeClass('open');
			$('.header-nav').removeClass('open');
		} else {
			$(this).addClass('open');
			$('.header-nav').addClass('open');
		}
	});
	$('.menu-close').click(function () {
		if ($('.sp-menu').hasClass('open')) {
			$('.sp-menu').removeClass('open');
			$('.header-nav').removeClass('open');
		} else {
			$('.sp-menu').addClass('open');
			$('.header-nav').addClass('open');
		}
	});


	if (document.getElementById('js-editor') != null) {
		$('#js-editor table').each(function () {
			$(this).wrap('<div class="tbl-responsive"></div>');
		});
		$('#js-editor iframe').each(function () {
			$(this).wrap('<div class="wrap-iframe"></div>');
		});
	}



	/* アニメーション */

	$(window).on('load scroll', function () {
		$('.lfn').each(function () {
			//ターゲットの位置を取得
			var target = $(this).offset().top;
			//スクロール量を取得
			var scroll = $(window).scrollTop();
			//ウィンドウの高さを取得
			var height = $(window).height();
			//ターゲットまでスクロールするとフェードインする
			if (scroll > target - height) {
				//クラスを付与
				$(this).addClass('fadeLeft');
			}
		});
		$('.rfn').each(function () {
			//ターゲットの位置を取得
			var target = $(this).offset().top;
			//スクロール量を取得
			var scroll = $(window).scrollTop();
			//ウィンドウの高さを取得
			var height = $(window).height();
			//ターゲットまでスクロールするとフェードインする
			if (scroll > target - height) {
				//クラスを付与
				$(this).addClass('fadeRight');
			}
		});
		$('.bfn').each(function () {
			//ターゲットの位置を取得
			var target = $(this).offset().top;
			//スクロール量を取得
			var scroll = $(window).scrollTop();
			//ウィンドウの高さを取得
			var height = $(window).height();
			//ターゲットまでスクロールするとフェードインする
			if (scroll > target - height) {
				//クラスを付与
				$(this).addClass('fadebtop');
			}
		});
	});

})(jQuery);






